<script setup>
// Astra DS · BotonApp — el acceso a una app: logotipo a color y dos líneas.
//
// Del nodo `apps 2839:361` del menú móvil (04.11.26): logotipo (`Brand/TestFlight`,
// `Brand/GooglePlay`) a 18 de alto, a 10 «PRUÉBALA EN» / «DISPONIBLE EN» en
// `mono/nano` `text/secondary` y debajo el nombre de la tienda en `mono/label`
// `text/primary`. El botón entero es el área táctil.
//
// Lo usan `NavSheet` (móvil) y la caja APP del pie de escritorio (Pablo,
// 04.11.26). El relleno, los filetes y el alto los pone quien lo coloca.
//
// Destinos, los que tenía la cabecera de escritorio: TestFlight lleva al alta,
// donde está la casilla de la beta; Android, a la ficha de Google Play.
import { useI18n } from "vue-i18n";
import { medir } from "@/services/medicion";
import TestFlightIcon from "@/components/icons/TestFlightIcon.vue";
import GooglePlayIcon from "@/components/icons/GooglePlayIcon.vue";

defineProps({
  tienda: {
    type: String,
    required: true,
    validator: (v) => ["testflight", "google-play"].includes(v),
  },
});

defineEmits(["navega"]);

const { t } = useI18n();
const GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=fm.astra.app";
</script>

<template>
  <router-link
    v-if="tienda === 'testflight'"
    class="boton-app"
    to="/cuenta?crear=1"
    @click="medir('descarga_app', { plataforma: 'ios' }), $emit('navega')"
  >
    <TestFlightIcon class="boton-app__logo" :size="18" />
    <span class="boton-app__texto">
      <span class="boton-app__kicker">{{ t("marco.cabecera.pruebalaEn") }}</span>
      <span class="boton-app__tienda">TestFlight</span>
    </span>
  </router-link>
  <a
    v-else
    class="boton-app"
    :href="GOOGLE_PLAY"
    target="_blank"
    rel="noopener"
    @click="medir('descarga_app', { plataforma: 'android' })"
  >
    <GooglePlayIcon class="boton-app__logo boton-app__logo--gp" />
    <span class="boton-app__texto">
      <span class="boton-app__kicker">{{ t("marco.cabecera.disponibleEn") }}</span>
      <span class="boton-app__tienda">Google Play</span>
    </span>
  </a>
</template>

<style scoped lang="scss">
@use "@/assets/scss/type" as t;

.boton-app {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: var(--color-text-primary);
  text-decoration: none;

  &:focus-visible {
    outline: 2px solid var(--color-border-focus);
    outline-offset: -2px;
  }
}

.boton-app__logo {
  flex: none;
}

// El de Google Play viene con `height: 1em`: se le da el cuerpo, 18.
.boton-app__logo--gp {
  font-size: 18px;
}

.boton-app__texto {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  white-space: nowrap;
}

.boton-app__kicker {
  @include t.mono-nano;
  color: var(--color-text-secondary);
}

.boton-app__tienda {
  @include t.mono-label;
  color: var(--color-text-primary);
}
</style>
